
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("645L8", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $2Nwuj = parcelRequire("2Nwuj");


var $6f0Oj = parcelRequire("6f0Oj");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $6r7Ix = parcelRequire("6r7Ix");

var $hjUk0 = parcelRequire("hjUk0");

var $6UUyu = parcelRequire("6UUyu");

var $4cOi8 = parcelRequire("4cOi8");

var $fOKpq = parcelRequire("fOKpq");


var $42omo = parcelRequire("42omo");


var $7CLBv = parcelRequire("7CLBv");


var $cUcZ5 = parcelRequire("cUcZ5");


var $7q60U = parcelRequire("7q60U");


var $aYtOO = parcelRequire("aYtOO");


var $dEsCs = parcelRequire("dEsCs");




const $dfe74c381b2e23bb$var$bfsTraverse = (items, callback)=>{
    const queue = [
        ...items
    ];
    while(queue.length > 0){
        const currentItem = queue.shift();
        if (callback(currentItem)) break;
        if (currentItem.type === (0, $dEsCs.ITEM).MENU && currentItem.childItems) queue.push(...currentItem.childItems);
    }
    return items;
};
const $dfe74c381b2e23bb$export$133e0070ec60504c = (items, item, parentId, position)=>{
    const addItemToParentInPlace = (itemsToTraverse, parentId, item, position)=>{
        return $dfe74c381b2e23bb$var$bfsTraverse(itemsToTraverse, (currentItem)=>{
            if (currentItem.itemId === parentId && currentItem.type === (0, $dEsCs.ITEM).MENU) {
                if (position !== undefined && position >= 0 && position <= currentItem.childItems.length) currentItem.childItems.splice(position, 0, item);
                else currentItem.childItems = [
                    ...currentItem.childItems || [],
                    item
                ];
                return true;
            }
            return false;
        });
    };
    let newItems;
    if (parentId !== undefined) newItems = addItemToParentInPlace(items, parentId, item, position);
    else {
        const itemsLength = items.length;
        const newPosition = position !== undefined && position >= 0 && position <= itemsLength ? position : itemsLength;
        newItems = [
            ...items
        ];
        newItems.splice(newPosition, 0, item);
    }
    return newItems;
};
const $dfe74c381b2e23bb$export$2d1285fd35af5519 = (items, updatedItem)=>{
    return $dfe74c381b2e23bb$var$bfsTraverse(items, (currentItem)=>{
        if (currentItem.itemId === updatedItem.itemId) {
            Object.assign(currentItem, updatedItem);
            return true;
        }
        return false;
    });
};
const $dfe74c381b2e23bb$export$49f42e821420f72e = (items, itemId)=>{
    return items.map((item)=>{
        if (item.type === (0, $dEsCs.ITEM).MENU && item.childItems) item.childItems = $dfe74c381b2e23bb$export$49f42e821420f72e(item.childItems, itemId);
        return item;
    }).filter((item)=>item.itemId !== itemId);
};


const $5057e99184510e30$var$MAXIMUM_ITEM_LIMIT = 50;
const $5057e99184510e30$var$MAXIMUM_NESTING_LEVELS = 5;
const $5057e99184510e30$export$8555315c03db9dc2 = ()=>$5057e99184510e30$var$MAXIMUM_ITEM_LIMIT;
const $5057e99184510e30$export$3fcb5b76d26bf473 = ()=>$5057e99184510e30$var$MAXIMUM_NESTING_LEVELS;
const $5057e99184510e30$export$b503abd6de82eca1 = (items)=>{
    return items?.reduce((acc, item)=>{
        return acc + 1 + $5057e99184510e30$export$b503abd6de82eca1(item?.childItems);
    }, 0) || 0;
};
const $5057e99184510e30$var$fetchLocalIdMacroParameters = (editorActions, localId)=>{
    const localIdNode = editorActions?.getNodeByLocalId?.(localId)?.toJSON();
    const params = localIdNode?.attrs?.parameters;
    // Return a copy of the params object if it exists, otherwise return null
    return params ? {
        ...params
    } : null;
};
const $5057e99184510e30$export$42f5e9ab021856ba = ()=>({
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        itemId: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))(),
        link: '',
        title: '',
        type: (0, $dEsCs.ITEM).LINK
    });
const $5057e99184510e30$export$8623c79a5744076b = ()=>({
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        itemId: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))(),
        childItems: [],
        title: '',
        type: (0, $dEsCs.ITEM).MENU
    });
const $5057e99184510e30$export$6c8e1d57a494d583 = (itemsToValidate)=>{
    if (!itemsToValidate || !Array.isArray(itemsToValidate)) return [];
    return itemsToValidate;
};
const $5057e99184510e30$export$404e7e78d12e7892 = (styles)=>{
    return {
        // use defaults to fill in any missing fields
        ...(0, $aYtOO.DEFAULT_STYLES),
        ...styles
    };
};
const $5057e99184510e30$export$579466658e10543a = ({ localId: localId, editorActions: editorActions })=>{
    const [extensionParameters, setExtensionParameters] = (0, $42omo.useState)(()=>$5057e99184510e30$var$fetchLocalIdMacroParameters(editorActions, localId));
    const { items: items } = extensionParameters ?? {};
    (0, $42omo.useEffect)(()=>{
        const extensionNodeParams = $5057e99184510e30$var$fetchLocalIdMacroParameters(editorActions, localId);
        setExtensionParameters(extensionNodeParams);
    }, [
        editorActions,
        localId
    ]);
    const updateExtensionParams = (0, $42omo.useCallback)((newExtensionParameters)=>{
        if (!extensionParameters) return;
        const updatedParams = {
            ...extensionParameters,
            ...newExtensionParameters
        };
        // Save params to ADF and state
        (0, $7q60U.updateNodeParameters)(editorActions, updatedParams);
        setExtensionParameters(updatedParams);
    }, [
        editorActions,
        extensionParameters
    ]);
    const addItem = (0, $42omo.useCallback)((item, parentId, position)=>{
        const clonedItems = (0, (/*@__PURE__*/$parcel$interopDefault($7CLBv)))(items);
        const updatedItems = (0, $dfe74c381b2e23bb$export$133e0070ec60504c)($5057e99184510e30$export$6c8e1d57a494d583(clonedItems), item, parentId, position);
        updateExtensionParams({
            items: updatedItems
        });
    }, [
        items,
        updateExtensionParams
    ]);
    const updateItem = (0, $42omo.useCallback)((item, title, link)=>{
        const newItem = (0, (/*@__PURE__*/$parcel$interopDefault($7CLBv)))(item);
        if (title) newItem.title = title;
        if (link) newItem.link = link;
        const clonedItems = (0, (/*@__PURE__*/$parcel$interopDefault($7CLBv)))(items);
        const updatedItems = (0, $dfe74c381b2e23bb$export$2d1285fd35af5519)($5057e99184510e30$export$6c8e1d57a494d583(clonedItems), newItem);
        updateExtensionParams({
            items: updatedItems
        });
    }, [
        items,
        updateExtensionParams
    ]);
    const moveItem = (0, $42omo.useCallback)((item, position, parentId)=>{
        const clonedItems = (0, (/*@__PURE__*/$parcel$interopDefault($7CLBv)))(items);
        const itemsWithoutOldEntry = (0, $dfe74c381b2e23bb$export$49f42e821420f72e)($5057e99184510e30$export$6c8e1d57a494d583(clonedItems), item.itemId);
        const itemsWithNewEntry = (0, $dfe74c381b2e23bb$export$133e0070ec60504c)(itemsWithoutOldEntry, item, parentId, position);
        updateExtensionParams({
            items: itemsWithNewEntry
        });
    }, [
        items,
        updateExtensionParams
    ]);
    const deleteItem = (0, $42omo.useCallback)((itemId)=>{
        const clonedItems = (0, (/*@__PURE__*/$parcel$interopDefault($7CLBv)))(items);
        const updatedItems = (0, $dfe74c381b2e23bb$export$49f42e821420f72e)($5057e99184510e30$export$6c8e1d57a494d583(clonedItems), itemId);
        updateExtensionParams({
            items: updatedItems
        });
    }, [
        items,
        updateExtensionParams
    ]);
    const createStyleUpdater = (0, $42omo.useCallback)((updateField)=>(value)=>{
            setExtensionParameters((prevParams)=>{
                if (!prevParams) return null;
                const newParams = {
                    ...prevParams,
                    styles: {
                        ...$5057e99184510e30$export$404e7e78d12e7892(prevParams.styles),
                        [updateField]: value
                    }
                };
                (0, $7q60U.updateNodeParameters)(editorActions, newParams);
                return newParams;
            });
        }, [
        editorActions
    ]);
    const extensionActions = (0, $42omo.useMemo)(()=>({
            addItem: addItem,
            updateItem: updateItem,
            moveItem: moveItem,
            deleteItem: deleteItem,
            updateAlignment: createStyleUpdater('alignment'),
            updateFillColor: createStyleUpdater('fillColor'),
            updateBorder: createStyleUpdater('border'),
            updateCornerStyle: createStyleUpdater('cornerStyle'),
            updateBorderColor: createStyleUpdater('borderColor'),
            updateTextColor: createStyleUpdater('textColor'),
            updateHighlightColor: createStyleUpdater('highlightColor')
        }), [
        addItem,
        updateItem,
        moveItem,
        deleteItem,
        createStyleUpdater
    ]);
    return {
        extensionParameters: extensionParameters,
        extensionActions: extensionActions
    };
};









var $bUlM5 = parcelRequire("bUlM5");




/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");





var $jJDs8 = parcelRequire("jJDs8");


var $4T4vf = parcelRequire("4T4vf");








var $jTxSS = parcelRequire("jTxSS");


var $dRnqM = parcelRequire("dRnqM");





var $ft7TS = parcelRequire("ft7TS");


var $bSjaC = parcelRequire("bSjaC");





var $882hS = parcelRequire("882hS");


var $afUmf = parcelRequire("afUmf");










const $d1435cf48f8ce5ef$var$draggingStyles = (0, $ecnYn.xcss)({
    opacity: 0.5
});
const $d1435cf48f8ce5ef$var$wrapperStyles = (0, $ecnYn.xcss)({
    position: 'relative',
    cursor: 'grab'
});
const $d1435cf48f8ce5ef$var$previewStyles = (0, $ecnYn.xcss)({
    paddingBlock: 'space.050',
    paddingInline: 'space.100',
    borderRadius: 'radius.small',
    backgroundColor: 'elevation.surface.overlay',
    maxWidth: '360px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $d1435cf48f8ce5ef$export$588e2663e0be32a3 = ({ children: children, item: item, isDragging: isDragging, setIsDragging: setIsDragging, index: index, parentId: parentId, level: level })=>{
    const ref = (0, $42omo.useRef)(null);
    const [dropIndicatorInstruction, setDropIndicatorInstruction] = (0, $42omo.useState)();
    const [previewContainer, setPreviewContainer] = (0, $42omo.useState)();
    (0, $42omo.useEffect)(()=>{
        const el = ref.current;
        (0, $dRnqM.default)(el);
        return (0, $bSjaC.combine)((0, $4T4vf.draggable)({
            element: el,
            onDragStart: ()=>setIsDragging(true),
            onDrop: ()=>setIsDragging(false),
            getInitialData: ()=>{
                return {
                    id: item.itemId,
                    parentId: parentId,
                    index: index,
                    type: item.type,
                    item: item
                };
            },
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                (0, $afUmf.setCustomNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage,
                    getOffset: (0, $882hS.pointerOutsideOfPreview)({
                        x: "var(--ds-space-200, 16px)",
                        y: "var(--ds-space-100, 8px)"
                    }),
                    render: ({ container: container })=>{
                        setPreviewContainer(container);
                    }
                });
            }
        }), (0, $4T4vf.dropTargetForElements)({
            element: el,
            canDrop: ()=>{
                // Stop user from dragging & dropping into deep nesting.
                // It's possible for users to work around our guardrails here and
                // and nest more levels than we "allow," by dragging and dropping already
                // deeply-nested trees into another deep nested target - as long as
                // the target element isn't exceeding the max level.
                // User will only be halted by some restrictions on the item creation buttons
                // and cursory checks like the ones below.
                // These guardrails are in place to 1. help admins make their content
                // accessible / well designed and 2. enforce scale limits.
                // With 1, we can let a user choose to work around that purposely, but they
                // still won't be able to get around our harder item number limit (see
                // MAXIMUM_ITEM_LIMIT) unless they directly query backend with an ADF update,
                // so 2 is not really a concern either.
                if (level > (0, $5057e99184510e30$export$3fcb5b76d26bf473)() + 1) return false;
                return true;
            },
            onDragLeave: ()=>{
                setDropIndicatorInstruction(null);
                setPreviewContainer(null);
            },
            onDrop: ()=>{
                setDropIndicatorInstruction(null);
                setPreviewContainer(null);
            },
            onDrag: ({ self: self, source: source })=>{
                const instruction = (0, $jJDs8.extractInstruction)(self.data);
                if (source.data.id === item.itemId || instruction?.type === 'instruction-blocked') setDropIndicatorInstruction(null);
                else setDropIndicatorInstruction(instruction);
            },
            getData: ({ input: input, element: element })=>{
                const data = {
                    id: item.itemId,
                    parentId: parentId,
                    index: index,
                    type: item.type,
                    item: item
                };
                // only menu items can be parents, so block make-child for links
                let blockInstructions = [
                    'make-child'
                ];
                if (item.type === (0, $dEsCs.ITEM).MENU) {
                    blockInstructions = [];
                    // Don't let user reorder-below a menu item that has children,
                    // because the drop indicator shows up under the menu item and
                    // doesn't visually represent the end state (current item will
                    // reorder *after* the menu *plus* all its children).
                    // User will still be able to achieve their desired goal by
                    // reordering above the subsequent item on the same level as
                    // this menu item.
                    // Exception is if this menu item is last in the list. In that case,
                    // they'll need to use a workaround for now by dragging the menu item
                    // upwards instead. @TODO, fix this papercut.
                    if (item.childItems?.length) blockInstructions.push('reorder-below');
                    if (level > (0, $5057e99184510e30$export$3fcb5b76d26bf473)()) blockInstructions.push('make-child');
                }
                return (0, $jJDs8.attachInstruction)(data, {
                    input: input,
                    element: element,
                    currentLevel: level,
                    indentPerLevel: 0,
                    mode: 'standard',
                    block: blockInstructions
                });
            }
        }));
    }, [
        item,
        setIsDragging,
        parentId,
        index,
        setDropIndicatorInstruction,
        level
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                ref: ref,
                xcss: [
                    isDragging && $d1435cf48f8ce5ef$var$draggingStyles,
                    $d1435cf48f8ce5ef$var$wrapperStyles
                ],
                testId: `draggable-links-menu-item-${item.itemId}`,
                children: [
                    children,
                    dropIndicatorInstruction ? /*#__PURE__*/ (0, $l998X.jsx)((0, $ft7TS.DropIndicator), {
                        instruction: dropIndicatorInstruction
                    }) : null
                ]
            }),
            previewContainer && /*#__PURE__*/ (0, $jTxSS.createPortal)(/*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $d1435cf48f8ce5ef$var$previewStyles,
                children: item.title
            }), previewContainer)
        ]
    });
};












var $1qfLF = parcelRequire("1qfLF");


var $9VJDA = parcelRequire("9VJDA");


var $lGgRw = parcelRequire("lGgRw");


















var $26itv = parcelRequire("26itv");


var $8jHAi = parcelRequire("8jHAi");


var $gj7hi = parcelRequire("gj7hi");


var $k00oi = parcelRequire("k00oi");

const $a8f9e22300e9eedd$export$17270ac458723b0f = async (link, submitError)=>{
    try {
        const client = new (0, $k00oi.default)();
        const resolvedLinkData = (await client.fetchData(link)).data || {};
        const isInternalResource = resolvedLinkData['atlassian:ari'];
        const externalIconUrl = resolvedLinkData.icon?.url;
        if (!isInternalResource && externalIconUrl) return externalIconUrl;
    } catch (error) {
        submitError?.(error);
    }
    return undefined;
};







const $89e0cdf44d444ddc$export$f508444e7933c2b1 = ({ item: item })=>{
    const [externalIconUrl, setExternalIconUrl] = (0, $42omo.useState)('');
    const link = item.type === (0, $dEsCs.ITEM).LINK ? item.link : '';
    const { submitError: submitError } = (0, $fOKpq.useProductDependencies)();
    (0, $42omo.useEffect)(()=>{
        const fetchIconComponent = async ()=>{
            if (link) {
                const url = await (0, $a8f9e22300e9eedd$export$17270ac458723b0f)(link, submitError);
                if (url) setExternalIconUrl(url);
            }
        };
        fetchIconComponent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        link
    ]);
    if (externalIconUrl) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
        src: externalIconUrl,
        height: 16,
        width: 16,
        alt: ""
    });
    if (item.type === (0, $dEsCs.ITEM).LINK) return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
        label: ""
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($26itv))), {
        label: ""
    });
};












var $inPa6 = parcelRequire("inPa6");


var $ccHMk = parcelRequire("ccHMk");


var $4iPjq = parcelRequire("4iPjq");










var $5qrxS = parcelRequire("5qrxS");


var $cVaAA = parcelRequire("cVaAA");








parcelRequire("42omo");





var $gQhRa = parcelRequire("gQhRa");

var $bfgIy = parcelRequire("bfgIy");







var $4noo5 = parcelRequire("4noo5");




const $0af8bf2cb593450b$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    displayTextLabel: {
        id: "company-hub.links-menu-extension.config-panel.property-config.display-text-label",
        defaultMessage: "Display text"
    },
    displayTextPlaceholder: {
        id: "company-hub.links-menu-extension.config-panel.property-config.display-text-placeholder",
        defaultMessage: "Item name"
    },
    displayTextError: {
        id: "company-hub.links-menu-extension.config-panel.property-config.display-text-error",
        defaultMessage: "Please fill out this field."
    }
});


const $a9c628c48a354c6b$var$errorStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.050',
    gap: 'space.050',
    height: '16px'
});
const $a9c628c48a354c6b$export$4a8624fe9f1d9d1e = ({ itemId: itemId, displayText: displayText, handleOnChange: handleOnChange, isInvalid: isInvalid })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $bfgIy.Label), {
                htmlFor: itemId,
                children: formatMessage((0, $0af8bf2cb593450b$export$defe85febe8b728c).displayTextLabel)
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $4noo5.default), {
                value: displayText,
                onChange: handleOnChange,
                placeholder: formatMessage((0, $0af8bf2cb593450b$export$defe85febe8b728c).displayTextPlaceholder),
                isInvalid: isInvalid,
                // link picker will still be able to insert a title longer than this
                // and there's no error messaging, but user will stop being able to
                // input more text after 100 chars
                maxLength: 100
            }),
            isInvalid && /*#__PURE__*/ (0, $l998X.jsx)((0, $bUlM5.default), {
                xcss: $a9c628c48a354c6b$var$errorStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                        ...(0, $0af8bf2cb593450b$export$defe85febe8b728c).displayTextError
                    })
                })
            })
        ]
    });
};





const $68d7d8a4d257133a$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    cancelButtonLabel: {
        id: "company-hub.links-menu-extension.config-panel.property-config.cancel-button-label",
        defaultMessage: "Cancel"
    },
    confirmButtonLabel: {
        id: "company-hub.links-menu-extension.config-panel.property-config.confirm-button-label",
        defaultMessage: "Confirm"
    }
});


const $cf11c166604040c5$var$configStyles = (0, $ecnYn.xcss)({
    margin: 'space.200',
    width: '310px'
});
const $cf11c166604040c5$var$buttonStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.200',
    justifyContent: 'flex-end',
    gap: 'space.050'
});
const $cf11c166604040c5$var$linkPickerCustomMessages = (0, $aXWIB.defineMessages)({
    submitButtonLabel: {
        id: "company-hub.links-menu-extension.config-panel.property-config.link.submit-button-label",
        defaultMessage: "Confirm"
    }
});
const $cf11c166604040c5$var$supportedPluginKeys = [
    'confluence',
    'jira',
    'atlas',
    'loom'
];
const $cf11c166604040c5$export$7aec99e1cacc0106 = ({ extensionActions: extensionActions, handleClose: handleClose, existingItem: existingItem, newItemType: newItemType, parentId: parentId, update: update })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { addItem: addItem, updateItem: updateItem } = extensionActions;
    const { cloudId: cloudId, linkPickerConfig: linkPickerConfig } = (0, $fOKpq.useProductDependencies)();
    // If create new type is passed in, create a new item with default parameters
    const [item] = (0, $42omo.useState)(()=>{
        if (newItemType === (0, $dEsCs.ITEM).LINK) return (0, $5057e99184510e30$export$42f5e9ab021856ba)();
        else if (newItemType === (0, $dEsCs.ITEM).MENU) return (0, $5057e99184510e30$export$8623c79a5744076b)();
        else return existingItem;
    });
    const [textFieldValue, setTextFieldValue] = (0, $42omo.useState)(item.title);
    const [isError, setIsError] = (0, $42omo.useState)(false);
    const handleTextFieldChange = (0, $42omo.useCallback)((event)=>{
        const { value: value } = event.target;
        setTextFieldValue(value);
        setIsError(false);
    }, []);
    // used for link item, extra step to handle link field
    const handleSubmitForLink = (payload)=>{
        // The link picker automatically submits when users select a
        // suggested link from the results, even if they have not
        // specified a title yet or hit Confirm. Here we interrupt
        // auto submission and set the display text to the link's title,
        // if none exists and we have a title from linking platform.
        // Then, when users hit Confirm manually the submission will happen.
        if (textFieldValue.length === 0 && payload.title) // If we have a page title from the link picker then set
        // empty display text to that value
        setTextFieldValue(payload.title);
        else // submit the update with link field
        handleSubmit(payload.url);
    };
    const handleSubmit = (link)=>{
        // do validation for display text field
        if (textFieldValue.length === 0) {
            setIsError(true);
            return;
        }
        // add item if new
        if (!!newItemType) {
            // set properties on new item
            item.title = textFieldValue;
            if (link) item.link = link;
            addItem(item, parentId);
        } else updateItem(item, textFieldValue, link);
        createAnalyticsEvent?.({
            type: 'sendTrackEvent',
            data: {
                action: !!newItemType ? 'added' : 'updated',
                actionSubject: 'item',
                source: (0, $cVaAA.LINKS_MENU_EXTENSION_ANALYTIC_SOURCE),
                attributes: {
                    itemType: item.link ? 'link' : 'menu'
                }
            }
        }).fire();
        handleClose();
    };
    const { isLoading: isLoading, plugins: plugins } = (0, $5qrxS.useLinkPickerPlugins)({
        cloudId: cloudId,
        product: 'confluence'
    });
    const filteredPlugins = (0, $42omo.useMemo)(()=>{
        return plugins.filter((plugin)=>{
            return plugin.tabKey && $cf11c166604040c5$var$supportedPluginKeys.includes(plugin.tabKey);
        });
    }, [
        plugins
    ]);
    // Use custom plugins if provided, otherwise use default filtered plugins
    const pluginsToUse = linkPickerConfig?.linkPickerPlugins || filteredPlugins;
    const isLoadingPlugins = linkPickerConfig?.linkPickerPlugins ? false : isLoading;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
        xcss: $cf11c166604040c5$var$configStyles,
        direction: "column",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $a9c628c48a354c6b$export$4a8624fe9f1d9d1e), {
                itemId: item.itemId,
                displayText: textFieldValue,
                handleOnChange: handleTextFieldChange,
                isInvalid: isError
            }),
            item.type === (0, $dEsCs.ITEM).LINK ? /*#__PURE__*/ (0, $l998X.jsx)((0, $4iPjq.default), {
                plugins: pluginsToUse,
                isLoadingPlugins: isLoadingPlugins,
                url: item.link,
                displayText: item.title,
                onSubmit: handleSubmitForLink,
                onCancel: handleClose,
                hideDisplayText: true,
                paddingLeft: "0px",
                paddingRight: "0px",
                paddingBottom: "0px",
                disableWidth: true,
                customMessages: $cf11c166604040c5$var$linkPickerCustomMessages,
                onContentResize: update
            }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
                xcss: $cf11c166604040c5$var$buttonStyles,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        appearance: "subtle",
                        onClick: handleClose,
                        children: formatMessage((0, $68d7d8a4d257133a$export$defe85febe8b728c).cancelButtonLabel)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        appearance: "primary",
                        onClick: ()=>handleSubmit(),
                        children: formatMessage((0, $68d7d8a4d257133a$export$defe85febe8b728c).confirmButtonLabel)
                    })
                ]
            })
        ]
    });
};












var $5tOl1 = parcelRequire("5tOl1");


var $56M4r = parcelRequire("56M4r");

var $cGtPE = parcelRequire("cGtPE");





var $3gadb = parcelRequire("3gadb");








parcelRequire("42omo");








var $1bY7o = parcelRequire("1bY7o");




var $2SlZp = parcelRequire("2SlZp");















const $4fad1d05da787347$var$message = (0, $aXWIB.defineMessages)({
    addLinkButtonText: {
        id: "company-hub.links-menu-extension.config-panel.add-link-button.text",
        defaultMessage: "Link"
    },
    addLinkButtonDescription: {
        id: "company-hub.links-menu-extension.config-panel.add-link-button.description",
        defaultMessage: "Add important links"
    },
    addMenuButtonText: {
        id: "company-hub.links-menu-extension.config-panel.add-menu-button.text",
        defaultMessage: "Menu"
    },
    addMenuButtonDescription: {
        id: "company-hub.links-menu-extension.config-panel.add-menu-button.description",
        defaultMessage: "Group related links together"
    },
    menuSubItemCreationDisabledTooltipText: {
        id: "company-hub.links-menu-extension.config-panel.add-menu-button.disabled.tooltip-text",
        defaultMessage: "You have reached the maximum number of nested levels."
    }
});
var $4fad1d05da787347$export$2e2bcd8739ae039 = $4fad1d05da787347$var$message;


const $32342ff509d3acae$var$menuGroupStyles = (0, $ecnYn.xcss)({
    width: '300px'
});
const $32342ff509d3acae$export$92ef8f592bb35119 = ({ setIsConfiguring: setIsConfiguring, setNewItemType: setNewItemType, isAddMenuSubItemDisabled: isAddMenuSubItemDisabled = false })=>{
    const intl = (0, $aXWIB.useIntl)();
    const handleAddLinkClick = ()=>{
        setIsConfiguring(true);
        setNewItemType((0, $dEsCs.ITEM).LINK);
    };
    const handleAddMenuClick = ()=>{
        setIsConfiguring(true);
        setNewItemType((0, $dEsCs.ITEM).MENU);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bUlM5.default), {
        xcss: $32342ff509d3acae$var$menuGroupStyles,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $2SlZp.default), {
            minWidth: "100%",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
                    iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
                        label: ""
                    }),
                    description: intl.formatMessage((0, $4fad1d05da787347$export$2e2bcd8739ae039).addLinkButtonDescription),
                    onClick: handleAddLinkClick,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                        ...(0, $4fad1d05da787347$export$2e2bcd8739ae039).addLinkButtonText
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                    content: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                        ...(0, $4fad1d05da787347$export$2e2bcd8739ae039).menuSubItemCreationDisabledTooltipText
                    }),
                    canAppear: ()=>isAddMenuSubItemDisabled,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
                        isDisabled: isAddMenuSubItemDisabled,
                        iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($26itv))), {
                            label: ""
                        }),
                        description: intl.formatMessage((0, $4fad1d05da787347$export$2e2bcd8739ae039).addMenuButtonDescription),
                        onClick: handleAddMenuClick,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                            ...(0, $4fad1d05da787347$export$2e2bcd8739ae039).addMenuButtonText
                        })
                    })
                })
            ]
        })
    });
};





















var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");


var $iXCQx = parcelRequire("iXCQx");










const $f63add754107d7a2$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    invokeDeleteButtonText: {
        id: "company-hub.links-menu-extension.config-panel.item-dropdown.delete-item-button.text",
        defaultMessage: "Delete item"
    },
    modalHeaderText: {
        id: "company-hub.links-menu-extension.config-panel.delete-nested-items-modal.title-text",
        defaultMessage: "Delete item"
    },
    modalDescriptionText: {
        id: "company-hub.links-menu-extension.config-panel.delete-nested-items-modal.description-text",
        defaultMessage: "This action will delete this item and all nested items."
    },
    confirmDeleteButtonText: {
        id: "company-hub.links-menu-extension.config-panel.delete-nested-items-modal.confirm-text",
        defaultMessage: "Delete"
    },
    cancelDeleteButtonText: {
        id: "company-hub.links-menu-extension.config-panel.delete-nested-items-modal.cancel-text",
        defaultMessage: "Cancel"
    }
});


const $203326bd7102f8ee$export$9ed99085725e367e = ({ item: item, extensionActions: extensionActions })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const openModal = ()=>setIsOpen(true);
    const closeModal = ()=>setIsOpen(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { deleteItem: deleteItem } = extensionActions;
    const handleDeleteClick = ()=>{
        if (item.type === (0, $dEsCs.ITEM).MENU && item.childItems?.length) openModal();
        else handleConfirmDelete();
    };
    const handleConfirmDelete = ()=>{
        createAnalyticsEvent?.({
            type: 'sendTrackEvent',
            data: {
                action: 'deleted',
                actionSubject: 'item',
                source: (0, $cVaAA.LINKS_MENU_EXTENSION_ANALYTIC_SOURCE),
                attributes: {
                    itemType: item.link ? 'link' : 'menu'
                }
            }
        }).fire();
        deleteItem(item.itemId);
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
                onClick: handleDeleteClick,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                    ...(0, $f63add754107d7a2$export$defe85febe8b728c).invokeDeleteButtonText
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
                children: isOpen && /*#__PURE__*/ (0, $l998X.jsxs)((0, $8CZUH.default), {
                    onClose: closeModal,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                            hasCloseButton: true,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                                appearance: "warning",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                    ...(0, $f63add754107d7a2$export$defe85febe8b728c).modalHeaderText
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1DHa6.default), {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                    ...(0, $f63add754107d7a2$export$defe85febe8b728c).modalDescriptionText
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $8o1lj.default), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                    appearance: "subtle",
                                    onClick: closeModal,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                        ...(0, $f63add754107d7a2$export$defe85febe8b728c).cancelDeleteButtonText
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                    appearance: "warning",
                                    onClick: handleConfirmDelete,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                        ...(0, $f63add754107d7a2$export$defe85febe8b728c).confirmDeleteButtonText
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};





const $e53391ea49829394$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    openLinkButtonText: {
        id: "company-hub.links-menu-extension.config-panel.item-dropdown.open-link-button.text",
        defaultMessage: "Open the link"
    },
    editPropertiesButtonText: {
        id: "company-hub.links-menu-extension.config-panel.item-dropdown.edit-properties-button.text",
        defaultMessage: "Edit properties"
    },
    addSubItemButtonText: {
        id: "company-hub.links-menu-extension.config-panel.item-dropdown.add-sub-item-button.text",
        defaultMessage: "Add sub item"
    },
    moveItemUpText: {
        id: "company-hub.links-menu-extension.config-panel.item-dropdown.move-item-up.text",
        defaultMessage: "Move up"
    },
    moveItemDownText: {
        id: "company-hub.links-menu-extension.config-panel.item-dropdown.move-item-down.text",
        defaultMessage: "Move down"
    },
    itemCreationDisabledTooltipText: {
        id: "company-hub.links-menu-extension.config-panel.sub-item-button.disabled.tooltip-text",
        defaultMessage: "You have reached the maximum number of items that can be added to a links menu."
    }
});


const $6c367ee0b50733b5$export$4837f2e6e199256e = ({ extensionActions: extensionActions, index: index, isFirst: isFirst, isLast: isLast, item: item, parentId: parentId, level: level, numberItems: numberItems, setIsPopupOpen: setIsPopupOpen, setIsConfiguring: setIsConfiguring, setNewItemType: setNewItemType })=>{
    const { moveItem: moveItem } = extensionActions;
    const [isNestedPopupOpen, setIsNestedPopupOpen] = (0, $42omo.useState)(false);
    const handleOpenLinkClick = ()=>{
        setIsPopupOpen(false);
    };
    const handleEditPropertiesClick = ()=>{
        setIsConfiguring(true);
        setNewItemType(undefined);
    };
    const handleMoveUpClick = ()=>{
        moveItem(item, index - 1, parentId);
        setIsPopupOpen(false);
    };
    const handleMoveDownClick = ()=>{
        moveItem(item, index + 1, parentId);
        setIsPopupOpen(false);
    };
    const handleSubItemPopupClose = ()=>setIsNestedPopupOpen(false);
    const reachedMaximumNestingLevel = level >= (0, $5057e99184510e30$export$3fcb5b76d26bf473)();
    const reachedMaximumItems = numberItems >= (0, $5057e99184510e30$export$8555315c03db9dc2)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            item.type === (0, $dEsCs.ITEM).LINK && /*#__PURE__*/ (0, $l998X.jsx)((0, $cGtPE.default), {
                href: item.link,
                target: "_blank",
                onClick: handleOpenLinkClick,
                isDisabled: !item.link,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                    ...(0, $e53391ea49829394$export$defe85febe8b728c).openLinkButtonText
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
                onClick: handleEditPropertiesClick,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                    ...(0, $e53391ea49829394$export$defe85febe8b728c).editPropertiesButtonText
                })
            }),
            item.type === (0, $dEsCs.ITEM).MENU && /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                content: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                    ...(0, $e53391ea49829394$export$defe85febe8b728c).itemCreationDisabledTooltipText
                }),
                canAppear: ()=>reachedMaximumItems,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
                    isOpen: isNestedPopupOpen,
                    placement: "auto",
                    onClose: handleSubItemPopupClose,
                    content: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $32342ff509d3acae$export$92ef8f592bb35119), {
                            isAddMenuSubItemDisabled: reachedMaximumNestingLevel,
                            setIsConfiguring: setIsConfiguring,
                            setNewItemType: setNewItemType
                        }),
                    trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
                            ...triggerProps,
                            isDisabled: reachedMaximumItems,
                            isSelected: isNestedPopupOpen,
                            onClick: ()=>setIsNestedPopupOpen(true),
                            iconAfter: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5tOl1))), {
                                label: "Add sub item"
                            }),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                ...(0, $e53391ea49829394$export$defe85febe8b728c).addSubItemButtonText
                            })
                        })
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
                isDisabled: isFirst,
                onClick: handleMoveUpClick,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                    ...(0, $e53391ea49829394$export$defe85febe8b728c).moveItemUpText
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
                isDisabled: isLast,
                onClick: handleMoveDownClick,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                    ...(0, $e53391ea49829394$export$defe85febe8b728c).moveItemDownText
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $203326bd7102f8ee$export$9ed99085725e367e), {
                item: item,
                extensionActions: extensionActions
            })
        ]
    });
};





const $8589a8b26ad6099a$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    moreButtonLabel: {
        id: "company-hub.links-menu-extension.config-panel.property-config.more-button-label",
        defaultMessage: "More"
    }
});


const $c91ef74706c70283$var$wrapperStyles = (0, $ecnYn.xcss)({
    height: '32px',
    paddingLeft: 'space.100',
    paddingRight: 'space.050'
});
const $c91ef74706c70283$var$unselectedStyles = (0, $ecnYn.xcss)({
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        borderRadius: 'radius.small'
    }
});
const $c91ef74706c70283$var$selectedStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.small',
    background: "var(--ds-background-selected, #E9F2FE)",
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-selected, #1868DB)"}`
});
const $c91ef74706c70283$var$entryStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
const $c91ef74706c70283$var$titleStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $c91ef74706c70283$export$b2ddf7d8171e1c98 = 16;
// Config panel is not resizable
const $c91ef74706c70283$var$APPROX_BUFFERED_CONFIG_PANEL_WIDTH = 255;
const $c91ef74706c70283$export$52cf4656f89a6ced = ({ extensionActions: extensionActions, isFirst: isFirst, isLast: isLast, index: index, item: item, parentId: parentId, level: level, numberItems: numberItems, isDragging: isDragging })=>{
    const [isPopupOpen, setIsPopupOpen] = (0, $42omo.useState)(false);
    const [isConfiguring, setIsConfiguring] = (0, $42omo.useState)(false);
    const [newItemType, setNewItemType] = (0, $42omo.useState)(undefined);
    const handleClose = ()=>{
        setIsPopupOpen(false);
        setIsConfiguring(false);
        setNewItemType(undefined);
    };
    const handleMoreButtonClick = ()=>{
        setIsPopupOpen(!isPopupOpen);
        setIsConfiguring(false);
        setNewItemType(undefined);
    };
    const configProps = newItemType ? {
        newItemType: newItemType,
        parentId: item.itemId
    } : {
        existingItem: item
    };
    const popupAdjustLeftPx = $c91ef74706c70283$var$APPROX_BUFFERED_CONFIG_PANEL_WIDTH - $c91ef74706c70283$export$b2ddf7d8171e1c98 * level;
    const popupAdjustDownPx = item?.type === (0, $dEsCs.ITEM).MENU ? 50 : 80;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
        alignItems: "center",
        justifyContent: "space-between",
        xcss: [
            $c91ef74706c70283$var$wrapperStyles,
            isConfiguring ? $c91ef74706c70283$var$selectedStyles : $c91ef74706c70283$var$unselectedStyles
        ],
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
                alignItems: "center",
                columnGap: "space.100",
                xcss: $c91ef74706c70283$var$entryStyles,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $89e0cdf44d444ddc$export$f508444e7933c2b1), {
                        item: item
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $c91ef74706c70283$var$titleStyles,
                        testId: `links-menu-item-title-${index}-${item.itemId}`,
                        children: item.title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
                isOpen: isPopupOpen && !isDragging,
                onClose: handleClose,
                placement: "auto",
                // move popup to left of list item when item config is invoked,
                // so user can see what they are editing
                offset: isConfiguring ? [
                    popupAdjustDownPx,
                    popupAdjustLeftPx
                ] : undefined,
                content: ({ update: update })=>{
                    if (isConfiguring) return /*#__PURE__*/ (0, $l998X.jsx)((0, $cf11c166604040c5$export$7aec99e1cacc0106), {
                        extensionActions: extensionActions,
                        handleClose: handleClose,
                        update: update,
                        ...configProps
                    });
                    else return /*#__PURE__*/ (0, $l998X.jsx)((0, $6c367ee0b50733b5$export$4837f2e6e199256e), {
                        extensionActions: extensionActions,
                        isFirst: isFirst,
                        isLast: isLast,
                        index: index,
                        level: level,
                        item: item,
                        parentId: parentId,
                        numberItems: numberItems,
                        setIsPopupOpen: setIsPopupOpen,
                        setIsConfiguring: setIsConfiguring,
                        setNewItemType: setNewItemType
                    });
                },
                trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        ...triggerProps,
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                        onClick: handleMoreButtonClick,
                        appearance: "subtle",
                        spacing: "compact",
                        label: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                            ...(0, $8589a8b26ad6099a$export$defe85febe8b728c).moreButtonLabel
                        }),
                        isSelected: isPopupOpen && !isConfiguring
                    })
            })
        ]
    });
};


const $1a3cd56968179363$var$treeStyles = null;
const $1a3cd56968179363$export$b7801be30ff65271 = ({ extensionActions: extensionActions, nodes: nodes, parentId: parentId, level: level = 0, numberItems: numberItems })=>{
    const { moveItem: moveItem } = extensionActions;
    (0, $42omo.useEffect)(()=>{
        return (0, $4T4vf.monitorForElements)({
            onDrop ({ source: source, location: location }) {
                const destination = location.current.dropTargets[0];
                if (destination?.data && source?.data) {
                    const sourceData = source.data;
                    const destinationData = destination.data;
                    const instruction = (0, $jJDs8.extractInstruction)(destinationData); // source and destination should be unique
                    if (sourceData.id !== destinationData.id) {
                        if (instruction?.type === 'reorder-above' || instruction?.type === 'reorder-below') {
                            // if source and destination have same parent, then we are reordering within the list
                            // and the index depends on whether the source is above or below the destination
                            const index = destinationData.index || 0;
                            let newIndex = instruction?.type === 'reorder-above' ? index : index + 1;
                            if (sourceData.parentId === destinationData.parentId) {
                                if (sourceData.index < index) newIndex = instruction?.type === 'reorder-above' ? index - 1 : index;
                            }
                            moveItem(sourceData.item, newIndex, destinationData.parentId);
                        }
                        if (instruction?.type === 'make-child') moveItem(sourceData.item, 0, destinationData.id);
                    }
                }
            }
        });
    }, [
        nodes,
        moveItem
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("ul", {
        style: {
            listStyleType: 'none'
        },
        className: (0, $gMc0m.default)([
            "_19bvidpf _17d4pxbi"
        ]),
        children: nodes.map((node, index)=>/*#__PURE__*/ (0, $l998X.jsx)($1a3cd56968179363$var$LinksMenuItemTreeNode, {
                extensionActions: extensionActions,
                node: node,
                isFirst: index === 0,
                isLast: index === nodes.length - 1,
                index: index,
                parentId: parentId,
                level: level,
                numberItems: numberItems
            }, node.itemId))
    });
};
const $1a3cd56968179363$var$LinksMenuItemTreeNode = ({ extensionActions: extensionActions, node: node, isFirst: isFirst, isLast: isLast, index: index, parentId: parentId, level: level, numberItems: numberItems })=>{
    const [isDragging, setIsDragging] = (0, $42omo.useState)(false);
    const newLevel = level + 1;
    return /*#__PURE__*/ (0, $l998X.jsxs)("li", {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $d1435cf48f8ce5ef$export$588e2663e0be32a3), {
                item: node,
                index: index,
                parentId: parentId,
                isDragging: isDragging,
                setIsDragging: setIsDragging,
                level: level,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $c91ef74706c70283$export$52cf4656f89a6ced), {
                    extensionActions: extensionActions,
                    index: index,
                    isFirst: isFirst,
                    isLast: isLast,
                    item: node,
                    parentId: parentId,
                    level: level,
                    numberItems: numberItems,
                    isDragging: isDragging
                }, node.itemId)
            }),
            node.childItems && !isDragging && /*#__PURE__*/ (0, $l998X.jsx)($1a3cd56968179363$export$b7801be30ff65271, {
                extensionActions: extensionActions,
                nodes: node.childItems,
                parentId: node.itemId,
                level: newLevel,
                numberItems: numberItems
            })
        ]
    });
};















var $g5gZt = parcelRequire("g5gZt");





var $1s5hv = parcelRequire("1s5hv");









const $69a95f59b03aafff$var$message = (0, $aXWIB.defineMessages)({
    newItemButtonText: {
        id: "company-hub.links-menu-extension.config-panel.new-item-button.text",
        defaultMessage: "New item"
    },
    itemCreationDisabledTooltipText: {
        id: "company-hub.links-menu-extension.config-panel.new-item-button.disabled.tooltip-text",
        defaultMessage: "You have reached the maximum number of items that can be added to a links menu."
    }
});
var $69a95f59b03aafff$export$2e2bcd8739ae039 = $69a95f59b03aafff$var$message;



const $f3b4fb25e12d94cb$export$f9da8ac0bf4c10b = ({ extensionActions: extensionActions, numberItems: numberItems })=>{
    const [isPopupOpen, setIsPopupOpen] = (0, $42omo.useState)(false);
    const [isConfiguring, setIsConfiguring] = (0, $42omo.useState)(false);
    const [newItemType, setNewItemType] = (0, $42omo.useState)(undefined);
    const handleOnClose = ()=>{
        setIsPopupOpen(false);
        setIsConfiguring(false);
        setNewItemType(undefined);
    };
    const isAddDisabled = numberItems >= (0, $5057e99184510e30$export$8555315c03db9dc2)();
    const handleAddNewItemButtonClick = ()=>{
        setIsPopupOpen(!isPopupOpen);
        setIsConfiguring(false);
        setNewItemType(undefined);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
        isOpen: isPopupOpen,
        onClose: handleOnClose,
        placement: "bottom-end",
        fallbackPlacements: [
            'auto'
        ],
        content: ({ update: update })=>isConfiguring && newItemType ? /*#__PURE__*/ (0, $l998X.jsx)((0, $cf11c166604040c5$export$7aec99e1cacc0106), {
                extensionActions: extensionActions,
                handleClose: handleOnClose,
                update: update,
                newItemType: newItemType
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $32342ff509d3acae$export$92ef8f592bb35119), {
                setIsConfiguring: setIsConfiguring,
                setNewItemType: setNewItemType
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                content: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                    ...(0, $69a95f59b03aafff$export$2e2bcd8739ae039).itemCreationDisabledTooltipText
                }),
                canAppear: ()=>isAddDisabled,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                    ...triggerProps,
                    onClick: handleAddNewItemButtonClick,
                    isSelected: isPopupOpen && !isConfiguring,
                    isDisabled: isAddDisabled,
                    shouldFitContainer: true,
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "space.050",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                                label: ""
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                ...(0, $69a95f59b03aafff$export$2e2bcd8739ae039).newItemButtonText
                            })
                        ]
                    })
                })
            })
    });
};


const $94cda8b8d3714c9c$var$itemsTabStyles = (0, $ecnYn.xcss)({
    width: '100%',
    paddingTop: 'space.200'
});
const $94cda8b8d3714c9c$var$itemsTreeStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.200'
});
const $94cda8b8d3714c9c$export$869bcddc95554001 = ({ extensionParameters: extensionParameters, extensionActions: extensionActions })=>{
    const totalItemCount = (0, $42omo.useMemo)(()=>(0, $5057e99184510e30$export$b503abd6de82eca1)(extensionParameters.items), [
        extensionParameters.items
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
        direction: "column",
        xcss: $94cda8b8d3714c9c$var$itemsTabStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $f3b4fb25e12d94cb$export$f9da8ac0bf4c10b), {
                extensionActions: extensionActions,
                numberItems: totalItemCount
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $bUlM5.default), {
                direction: "column",
                xcss: $94cda8b8d3714c9c$var$itemsTreeStyles,
                children: extensionParameters.items && /*#__PURE__*/ (0, $l998X.jsx)((0, $1a3cd56968179363$export$b7801be30ff65271), {
                    extensionActions: extensionActions,
                    nodes: extensionParameters.items,
                    numberItems: totalItemCount
                })
            })
        ]
    });
};





const $33bf5063f49bb90c$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    title: {
        id: "company-hub.links-menu-extension.config-panel.title",
        defaultMessage: "Links menu"
    },
    preamble: {
        id: "company-hub.links-menu-extension.config-panel.preamble",
        defaultMessage: "Add links and organize them with submenus. {linksMenuSupportLink}"
    },
    preambleWithoutSupportLink: {
        id: "company-hub.links-menu-extension.config-panel.preamble-without-support-link",
        defaultMessage: "Add links and organize them with submenus."
    },
    preambleSupportLinkLabel: {
        id: "company-hub.links-menu-extension.config-panel.preamble-link.label",
        defaultMessage: "Learn more about links menu"
    },
    itemsLabel: {
        id: "company-hub.links-menu-extension.config-panel.items.label",
        defaultMessage: "Items"
    },
    stylesLabel: {
        id: "company-hub.links-menu-extension.config-panel.styles.label",
        defaultMessage: "Styles"
    }
});





parcelRequire("42omo");







var $fQWPs = parcelRequire("fQWPs");

var $7Ux0V = parcelRequire("7Ux0V");




/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");








var $u9agA = parcelRequire("u9agA");

var $fVUfS = parcelRequire("fVUfS");

var $eyWa4 = parcelRequire("eyWa4");


var $kZ5GD = parcelRequire("kZ5GD");


var $8eOJy = parcelRequire("8eOJy");

var $a06aa53e5203bfe6$exports = {};
$a06aa53e5203bfe6$exports = new URL("CenterAlignment.d485d2ee.svg", import.meta.url).toString();

var $a849093f5fe2e3c6$exports = {};
$a849093f5fe2e3c6$exports = new URL("LeftAlignment.39a4cc93.svg", import.meta.url).toString();

var $116b0932a6c1f897$exports = {};
$116b0932a6c1f897$exports = new URL("RightAlignment.ee73794d.svg", import.meta.url).toString();








const $6915fd8baa9f67e0$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    alignmentSectionTitle: {
        id: "company-hub.links-menu-extension.alignment.title",
        defaultMessage: "Alignment"
    },
    centerOption: {
        id: "company-hub.links-menu-extension.center.option",
        defaultMessage: "Center"
    },
    rightOption: {
        id: "company-hub.links-menu-extension.right.option",
        defaultMessage: "Right"
    },
    leftOption: {
        id: "company-hub.links-menu-extension.left.option",
        defaultMessage: "Left"
    },
    collapseSectionLabel: {
        id: "company-hub.links-menu-extension.section.collapse.label",
        defaultMessage: "Collapse section"
    },
    expandSectionLabel: {
        id: "company-hub.links-menu-extension.section.expand.label",
        defaultMessage: "Expand section"
    },
    fixedOption: {
        id: "company-hub.links-menu-extension.fixed.option",
        defaultMessage: "Fixed at top"
    }
});


const $46a78acf4a28569a$var$styles = {
    options: "_2rko12b0 _1h6d1l7x _189ee4h9 _1dqonqa1 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _bfhksm61 _4cvxq98m _irr3daj9"
};
const $46a78acf4a28569a$export$f77ede0ff8fdecea = ({ alignment: alignment, updateAlignment: updateAlignment })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const alignmentOptions = [
        {
            option: (0, $dEsCs.ALIGNMENT).CENTER,
            label: (0, $6915fd8baa9f67e0$export$defe85febe8b728c).centerOption,
            image: (0, (/*@__PURE__*/$parcel$interopDefault($a06aa53e5203bfe6$exports)))
        },
        {
            option: (0, $dEsCs.ALIGNMENT).RIGHT,
            label: (0, $6915fd8baa9f67e0$export$defe85febe8b728c).rightOption,
            image: (0, (/*@__PURE__*/$parcel$interopDefault($116b0932a6c1f897$exports)))
        },
        {
            option: (0, $dEsCs.ALIGNMENT).LEFT,
            label: (0, $6915fd8baa9f67e0$export$defe85febe8b728c).leftOption,
            image: (0, (/*@__PURE__*/$parcel$interopDefault($a849093f5fe2e3c6$exports)))
        }
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $8eOJy.CollapsibleItem), {
        title: formatMessage((0, $6915fd8baa9f67e0$export$defe85febe8b728c).alignmentSectionTitle),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
            space: "space.200",
            children: alignmentOptions.map(({ option: option, label: label, image: image })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                    xcss: $46a78acf4a28569a$var$styles.options,
                    onClick: ()=>updateAlignment(option),
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        spread: "space-between",
                        alignBlock: "center",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $kZ5GD.default), {
                                value: "default radio",
                                label: formatMessage(label),
                                name: `radio-${option}`,
                                testId: `radio-${option}${alignment === option ? '--selected' : ''}`,
                                isChecked: alignment === option
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                                src: image,
                                alt: ""
                            })
                        ]
                    })
                }, option))
        })
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





var $1Whri = parcelRequire("1Whri");


var $6oGZN = parcelRequire("6oGZN");


var $aRCWA = parcelRequire("aRCWA");


var $bvjDB = parcelRequire("bvjDB");














var $5n7dr = parcelRequire("5n7dr");

var $1u5CA = parcelRequire("1u5CA");







var $aPCur = parcelRequire("aPCur");







const $7b76fabc12c740f9$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    backgroundTitle: {
        id: "company-hub.links-menu-extension.background.title",
        defaultMessage: "Background"
    },
    backgroundColor: {
        id: "company-hub.links-menu-extension.background.color",
        defaultMessage: "Background color"
    },
    borderColor: {
        id: "company-hub.links-menu-extension.border.color",
        defaultMessage: "Border color"
    },
    borderPosition: {
        id: "company-hub.links-menu-extension.border.position",
        defaultMessage: "Border position"
    },
    noBorderLabel: {
        id: "company-hub.links-menu-extension.no.border.label-text",
        defaultMessage: "None"
    },
    allBordersLabel: {
        id: "company-hub.links-menu-extension.all.borders.label-text",
        defaultMessage: "All sides"
    },
    bottomBorderLabel: {
        id: "company-hub.links-menu-extension.bottom.border.label-text",
        defaultMessage: "Bottom border"
    }
});


const $a2d8192543b6a91c$var$styles = {
    borderOptionContainer: "_1rjcv77o _18zr1b66 _bfhkysee",
    dropdownTrigger: "_bfhksm61",
    border: "_2rko12b0 _189ee4h9 _1h6d1l7x _1dqonqa1",
    selected: "_1h6d1w55 _bfhk15s3"
};
const $a2d8192543b6a91c$export$caf212aab59548f5 = ({ border: border, updateBorder: updateBorder, borderColor: borderColor, updateBorderColor: updateBorderColor, fillColor: fillColor, updateFillColor: updateFillColor, cornerStyle: cornerStyle, updateCornerStyle: updateCornerStyle, isReadableFillColor: isReadableFillColor })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { isSSRProductInDarkMode: isSSRProductInDarkMode } = (0, $fOKpq.useProductDependencies)();
    const { branding: branding } = (0, $fOKpq.useProductDependencies)();
    const { hideDefaultColorPalette: hideDefaultColorPalette, brandBackgroundColorMap: brandBackgroundColorMap } = branding ?? {};
    const { backgroundColorMap: backgroundColorMap, borderColorMap: borderColorMap, emptyColorMap: emptyColorMap } = (0, $1u5CA.useBuiltInColorMap)(isSSRProductInDarkMode);
    const handleBorderColorChange = (color)=>{
        if (border === (0, $dEsCs.BORDER).NONE) // if user interacts with border color then they need a border
        // position in order to see their changes
        updateBorder((0, $dEsCs.BORDER).ALL_SIDES);
        updateBorderColor(color);
    };
    const handleBorderOptionClick = (borderOption)=>updateBorder(borderOption);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $8eOJy.CollapsibleItem), {
        title: formatMessage((0, $7b76fabc12c740f9$export$defe85febe8b728c).backgroundTitle),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            space: "space.200",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    alignBlock: "center",
                    spread: "space-between",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            color: "color.text",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                ...(0, $7b76fabc12c740f9$export$defe85febe8b728c).backgroundColor
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $5n7dr.ColorPicker), {
                            analyticsSource: "linksMenuExtensionConfigBackgroundColor",
                            builtInColorMap: hideDefaultColorPalette && brandBackgroundColorMap ? brandBackgroundColorMap : backgroundColorMap,
                            isReadableColor: isReadableFillColor,
                            onChange: updateFillColor,
                            value: fillColor,
                            pickerTitle: (0, $7b76fabc12c740f9$export$defe85febe8b728c).backgroundColor,
                            showCustomPalette: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    alignBlock: "center",
                    spread: "space-between",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                ...(0, $7b76fabc12c740f9$export$defe85febe8b728c).borderPosition
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                            space: "space.100",
                            children: [
                                {
                                    borderOption: (0, $dEsCs.BORDER).NONE,
                                    label: (0, $7b76fabc12c740f9$export$defe85febe8b728c).noBorderLabel,
                                    IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($aRCWA)))
                                },
                                {
                                    borderOption: (0, $dEsCs.BORDER).ALL_SIDES,
                                    label: (0, $7b76fabc12c740f9$export$defe85febe8b728c).allBordersLabel,
                                    IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($6oGZN)))
                                },
                                {
                                    borderOption: (0, $dEsCs.BORDER).BOTTOM,
                                    label: (0, $7b76fabc12c740f9$export$defe85febe8b728c).bottomBorderLabel,
                                    IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($bvjDB)))
                                }
                            ].map(({ borderOption: borderOption, label: label, IconComponent: IconComponent })=>{
                                return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                                    content: formatMessage(label),
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                                        xcss: (0, $1Whri.cx)($a2d8192543b6a91c$var$styles.borderOptionContainer, $a2d8192543b6a91c$var$styles.border, border === borderOption && $a2d8192543b6a91c$var$styles.selected),
                                        onClick: ()=>handleBorderOptionClick(borderOption),
                                        testId: `border-${borderOption}${border === borderOption ? '--selected' : ''}`,
                                        children: /*#__PURE__*/ (0, $l998X.jsx)(IconComponent, {
                                            color: border === borderOption ? "var(--ds-icon-accent-blue, #357DE8)" : "var(--ds-icon, #292A2E)",
                                            label: formatMessage(label)
                                        })
                                    })
                                }, borderOption);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    alignBlock: "center",
                    spread: "space-between",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            color: "color.text",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                ...(0, $7b76fabc12c740f9$export$defe85febe8b728c).borderColor
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $5n7dr.ColorPicker), {
                            analyticsSource: "linksMenuExtensionConfigBorderColor",
                            builtInColorMap: hideDefaultColorPalette ? emptyColorMap : borderColorMap,
                            onChange: (color)=>color && handleBorderColorChange(color),
                            value: borderColor,
                            pickerTitle: (0, $7b76fabc12c740f9$export$defe85febe8b728c).borderColor,
                            showCustomPalette: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $aPCur.CornerStyleConfig), {
                    cornerStyleValue: cornerStyle,
                    updateCornerStyle: updateCornerStyle,
                    roundCornerValue: (0, $dEsCs.CORNERS).ROUND,
                    squareCornerValue: (0, $dEsCs.CORNERS).SHARP
                })
            ]
        })
    });
};





parcelRequire("42omo");
























const $b4baa449f71fea5b$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    textTitle: {
        id: "company-hub.links-menu-extension.text.title",
        defaultMessage: "Text"
    },
    textColor: {
        id: "company-hub.links-menu-extension.text.color",
        defaultMessage: "Text color"
    },
    selectedStateColor: {
        id: "company-hub.links-menu-extension.selected.state.color",
        defaultMessage: "Selected state color"
    }
});


const $421aadecfadfc2d2$export$b8599b1e18c4960e = ({ highlightColor: highlightColor, updateHighlightColor: updateHighlightColor, textColor: textColor, updateTextColor: updateTextColor, isReadableTextColor: isReadableTextColor })=>{
    const { isSSRProductInDarkMode: isSSRProductInDarkMode } = (0, $fOKpq.useProductDependencies)();
    const { branding: branding } = (0, $fOKpq.useProductDependencies)();
    const { hideDefaultColorPalette: hideDefaultColorPalette } = branding ?? {};
    const { highlightColorMap: highlightColorMap, textColorMap: textColorMap, emptyColorMap: emptyColorMap } = (0, $1u5CA.useBuiltInColorMap)(isSSRProductInDarkMode);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $8eOJy.CollapsibleItem), {
        title: formatMessage((0, $b4baa449f71fea5b$export$defe85febe8b728c).textTitle),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            space: "space.200",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    spread: "space-between",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            color: "color.text",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                ...(0, $b4baa449f71fea5b$export$defe85febe8b728c).textColor
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $5n7dr.ColorPicker), {
                            analyticsSource: "linksMenuExtensionConfigTextColor",
                            builtInColorMap: hideDefaultColorPalette ? emptyColorMap : textColorMap,
                            isReadableColor: isReadableTextColor,
                            onChange: updateTextColor,
                            value: textColor,
                            pickerTitle: (0, $b4baa449f71fea5b$export$defe85febe8b728c).textColor,
                            showCustomPalette: true,
                            showTextIcon: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    spread: "space-between",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            color: "color.text",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                ...(0, $b4baa449f71fea5b$export$defe85febe8b728c).selectedStateColor
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $5n7dr.ColorPicker), {
                            analyticsSource: "linksMenuExtensionConfigHighlightColor",
                            builtInColorMap: hideDefaultColorPalette ? emptyColorMap : highlightColorMap,
                            onChange: updateHighlightColor,
                            value: highlightColor,
                            pickerTitle: (0, $b4baa449f71fea5b$export$defe85febe8b728c).selectedStateColor,
                            showCustomPalette: true
                        })
                    ]
                })
            ]
        })
    });
};


const $7d542d9d96e11c70$var$stylesTabStyles = (0, $ecnYn.xcss)({
    width: '100%'
});
const $7d542d9d96e11c70$export$3989a31619203135 = ({ parameters: parameters, actions: actions })=>{
    const { styles: styles } = parameters ?? {};
    const { updateBorder: updateBorder, updateBorderColor: updateBorderColor, updateCornerStyle: updateCornerStyle, updateFillColor: updateFillColor, updateHighlightColor: updateHighlightColor, updateTextColor: updateTextColor } = actions;
    const isReadableFillColor = (color)=>(0, $fQWPs.isReadable)(color, styles.textColor);
    const isReadableTextColor = (color)=>(0, $fQWPs.isReadable)(color, styles.fillColor);
    const { branding: branding } = (0, $fOKpq.useProductDependencies)();
    (0, $7Ux0V.useAutoTransitioningColors)(styles.fillColor, isReadableTextColor, styles.textColor, updateTextColor, branding?.defaultParameters);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
        direction: "column",
        xcss: $7d542d9d96e11c70$var$stylesTabStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $46a78acf4a28569a$export$f77ede0ff8fdecea), {
                updateAlignment: actions.updateAlignment,
                alignment: parameters.styles.alignment
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $a2d8192543b6a91c$export$caf212aab59548f5), {
                border: styles.border,
                updateBorder: updateBorder,
                borderColor: styles.borderColor,
                updateBorderColor: updateBorderColor,
                fillColor: styles.fillColor,
                updateFillColor: updateFillColor,
                cornerStyle: styles.cornerStyle,
                updateCornerStyle: updateCornerStyle,
                isReadableFillColor: isReadableFillColor
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $421aadecfadfc2d2$export$b8599b1e18c4960e), {
                highlightColor: styles.highlightColor,
                updateHighlightColor: updateHighlightColor,
                textColor: styles.textColor,
                updateTextColor: updateTextColor,
                isReadableTextColor: isReadableTextColor
            })
        ]
    });
};


const $8d8e9f6f1461887c$var$SUPPORT_LINK = 'https://support.atlassian.com/confluence-cloud/docs/set-up-a-menu-of-important-links-on-company-hub/';
const $8d8e9f6f1461887c$var$stickyFooterStyles = (0, $ecnYn.xcss)({
    paddingInline: 'space.050',
    paddingBlock: 'space.300',
    marginInline: 'space.negative.050',
    display: 'flex',
    flexDirection: 'column',
    position: 'sticky',
    bottom: 'space.0',
    backgroundColor: 'elevation.surface'
});
const $8d8e9f6f1461887c$var$LinksMenuFooter = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $8d8e9f6f1461887c$var$stickyFooterStyles,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6r7Ix.ConfigPanelFeedbackCollector), {
            source: "linksMenuExtension",
            type: (0, $4cOi8.FeedbackType).LINKS_MENU
        })
    });
const $8d8e9f6f1461887c$export$d4ee58941fdf2d2c = ({ closeConfigPanel: closeConfigPanel, localId: localId, editorActions: editorActions })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { showConfigPreambleSupportLink: showConfigPreambleSupportLink } = (0, $fOKpq.useProductDependencies)();
    const { extensionParameters: extensionParameters, extensionActions: extensionActions } = (0, $5057e99184510e30$export$579466658e10543a)({
        localId: localId,
        editorActions: editorActions
    });
    if (!extensionParameters) return null;
    const tabSections = [
        {
            label: formatMessage((0, $33bf5063f49bb90c$export$defe85febe8b728c).itemsLabel),
            value: 'items',
            tabContent: [
                {
                    sectionId: 'main',
                    component: /*#__PURE__*/ (0, $l998X.jsx)((0, $94cda8b8d3714c9c$export$869bcddc95554001), {
                        extensionParameters: extensionParameters,
                        extensionActions: extensionActions
                    })
                }
            ]
        },
        {
            label: formatMessage((0, $33bf5063f49bb90c$export$defe85febe8b728c).stylesLabel),
            value: 'styles',
            tabContent: [
                {
                    sectionId: 'general',
                    component: /*#__PURE__*/ (0, $l998X.jsx)((0, $7d542d9d96e11c70$export$3989a31619203135), {
                        parameters: extensionParameters,
                        actions: extensionActions
                    })
                }
            ]
        }
    ];
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6UUyu.ExtensionsConfigWrapper), {
        title: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            ...(0, $33bf5063f49bb90c$export$defe85febe8b728c).title
        }),
        footerComponent: $8d8e9f6f1461887c$var$LinksMenuFooter,
        closeConfigPanel: closeConfigPanel,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                    ...showConfigPreambleSupportLink ? (0, $33bf5063f49bb90c$export$defe85febe8b728c).preamble : (0, $33bf5063f49bb90c$export$defe85febe8b728c).preambleWithoutSupportLink,
                    values: {
                        linksMenuSupportLink: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                            target: "_blank",
                            href: $8d8e9f6f1461887c$var$SUPPORT_LINK,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                ...(0, $33bf5063f49bb90c$export$defe85febe8b728c).preambleSupportLinkLabel
                            })
                        })
                    }
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $hjUk0.ConfigPanelGrouping), {
                source: "linksMenuExtensionConfig",
                tabSections: tabSections
            })
        ]
    });
};
module.exports["LinksMenuConfigPanelContent"] = $8d8e9f6f1461887c$export$d4ee58941fdf2d2c;

});


//# sourceMappingURL=links-menu-extension.bfde1bf8.js.map
